'use strict';
import isFunction from 'lodash/isFunction';
import React from 'react';
import {componentFromStream, createEventHandler} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import {ButtonState} from '../../../core-utilities/enums/ButtonState';
import {FormModalView} from './FormModalView';

/**
 * @param WrappedComponent
 * @param {Object} modalProps
 * @param {String} modalProps.modalHeaderLabel
 * @param {Object} [childProps={}]
 * @return {*}
 * @constructor
 */
export const FormModalHOC = (WrappedComponent, modalProps, childProps) => componentFromStream(props$ => {
  const {
    handler: onTriggerSave,
    stream: triggerSave$,
  } = createEventHandler();

  const {
    handler: onCancel,
    stream: cancel$,
  } = createEventHandler();

  cancel$
    .withLatestFrom(props$)
    .takeUntil(props$.last())
    .subscribe(([e, props]) => {
      e.stopPropagation();
      if (isFunction(props.onCancel)) {
        props.onCancel();
      }
    });

  return props$
    .combineLatest(
      (props) => (
        <FormModalView
          className={props.className}
          mode={props.mode}
          onCancel={onCancel}
          onTriggerSave={onTriggerSave}
          modalHeaderLabel={modalProps.modalHeaderLabel}
        >
          <WrappedComponent
            model={props.model}
            isEditing={true}
            isSaving={props.mode !== ButtonState.START}
            onSave={props.onSave}
            triggerSave$={triggerSave$}
            {...(childProps || {})}
          />
        </FormModalView>
      ));
});



// WEBPACK FOOTER //
// ./src/js/components/modals/FormModal/FormModalComponent.js